/**
 * TODO: Replace the copypasta lengthTextUtl function with this one.
 * Returns a string that describes the character limit for a given maximum length and current length.
 *
 * If the maximum length is greater than 0, the function calculates the number of characters left until
 * the limit is reached, and returns a string that indicates whether there are characters left or the
 * limit has been reached.
 *
 * @param {number} maxLength - The maximum number of characters allowed.
 * @param {number} currentLength - The current number of characters.
 * @returns {(string)} A string that describes the character limit
 */
export default function getTextForCharacterLimit(
  maxLength: number,
  currentLength: number,
) {
  const count = maxLength - currentLength;

  return count === 0
    ? `Character limit of ${maxLength} reached`
    : `Characters left: ${count}`;
}
